import { Link } from "react-router-dom";
import { ChevronRight, MessageCircle, Phone } from "lucide-react";
import { CONTACT, WHATSAPP_BASE } from "@/data/site";

export const Eyebrow = ({ children }) => (
  <span className="inline-flex items-center rounded-full bg-brand-soft px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wider text-brand-primary">
    {children}
  </span>
);

export const SectionHeading = ({ eyebrow, title, subtitle, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
    <h2 className="mt-4 font-heading text-3xl font-bold leading-tight text-brand-ink sm:text-4xl">
      {title}
    </h2>
    {subtitle && (
      <p className="mt-4 text-base leading-relaxed text-brand-slate md:text-lg">
        {subtitle}
      </p>
    )}
  </div>
);

export const Breadcrumbs = ({ items }) => (
  <nav
    className="flex flex-wrap items-center gap-1.5 text-sm text-brand-slate"
    data-testid="breadcrumbs"
    aria-label="Breadcrumb"
  >
    {items.map((item, i) => (
      <span key={i} className="flex items-center gap-1.5">
        {item.to ? (
          <Link
            to={item.to}
            className="transition-colors hover:text-brand-primary"
          >
            {item.label}
          </Link>
        ) : (
          <span className="font-medium text-brand-ink">{item.label}</span>
        )}
        {i < items.length - 1 && (
          <ChevronRight className="h-3.5 w-3.5 text-brand-slate/60" />
        )}
      </span>
    ))}
  </nav>
);

export const CTABand = ({
  title = "Ready to discuss your ENT surgery?",
  subtitle = "Book a consultation with Dr. Sanjay Teza for an accurate diagnosis and a transparent, honest treatment plan.",
  whatsappText = "Hello Dr. Sanjay Teza, I would like to book a surgical consultation.",
}) => (
  <section className="bg-brand-primary" data-testid="cta-band">
    <div className="mx-auto max-w-7xl px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div className="flex flex-col items-start justify-between gap-8 lg:flex-row lg:items-center">
        <div className="max-w-2xl">
          <h2 className="font-heading text-2xl font-bold text-white sm:text-3xl">
            {title}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-brand-soft">
            {subtitle}
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row">
          <a
            href={`${WHATSAPP_BASE}?text=${encodeURIComponent(whatsappText)}`}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cta-band-whatsapp"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-brand-primary transition-transform duration-200 hover:-translate-y-0.5"
          >
            <MessageCircle className="h-5 w-5" /> Book on WhatsApp
          </a>
          <a
            href={`tel:${CONTACT.phoneRaw}`}
            data-testid="cta-band-call"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/40 px-6 py-3.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-white/10"
          >
            <Phone className="h-5 w-5" /> Call {CONTACT.phone}
          </a>
        </div>
      </div>
    </div>
  </section>
);
